exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-come-back[data-v-8050a4b2]{background-color:#0d6247;cursor:pointer;color:#fff}.button-come-back[data-v-8050a4b2]:hover{background-color:#ea7b27}", ""]);

// exports
